import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PrizesAndPerksService } from 'src/app/core/services/prizes-and-perks/prizes-and-perks.service';

@Component({
  selector: 'app-prizes-and-perks',
  templateUrl: './prizes-and-perks.component.html',
  styleUrls: ['./prizes-and-perks.component.css']
})
export class PrizesAndPerksComponent implements OnInit {

  constructor(private dialog: MatDialog,
              private prizeService: PrizesAndPerksService) { }

  box1: any;
  box2: any;
  box3: any;
  dialogData: any;
  mainTitle: string = '';
  mainTitleDescription: string = '';
  section2Heading: string = '';
  section2Description: string = '';
  section3Heading: string = '';
  section3Description: string = '';
  section4Heading: string = '';
  section4Description: string = '';
  boxColor: string;
  perkcards = [];
  steps = [];
  cards = [];
  pageLoad: boolean = false;

  ngOnInit(): void {
    this.prizeService.getPrizesAndPerksList().subscribe(item => {
      const data = item;
      //Section 1
      const section1 = item.filter(sec => sec.step === '1');
      this.mainTitle = section1[0].title;
      this.mainTitleDescription = section1[0].sub_title;
      //Section 2
      const section2 = item.filter(sec => sec.step === '2');
      const section2Main = section2.filter(sec => sec.type === 'HEADER');
      this.perkcards = section2.filter(sec => sec.type === 'CONTENT');
      this.section2Heading = section2Main[0].title;
      this.section2Description = section2Main[0].sub_title;
      //Section 3
      const section3 = item.filter(sec => sec.step === '3');
      const section3Main = section3.filter(sec => sec.type === 'HEADER');
      this.section3Heading = section3Main[0].title;
      this.section3Description = section3Main[0].sub_title;
      this.cards = section3.filter(sec => sec.type === 'CONTENT');
      // this.box1 = this.cards[0];
      // this.box2 = this.cards[1];
      // this.box3 = this.cards[2];
      //Section 4
      const section4 = item.filter(sec => sec.step === '4');
      const section4Main = section4.filter(sec => sec.type === 'HEADER');
      this.section4Heading = section4Main[0].title;
      // this.section4Description = section4Main[0].sub_title;
      this.steps = section4.filter(sec => sec.type === 'CONTENT');

      this.pageLoad = true;
    });
  }

  openDialog(templateRef: TemplateRef<any>, boxData: any, color:any){
    this.boxColor = color;
    this.dialogData = boxData;
    this.dialog.open(templateRef); 
  }

  close() {
    this.dialog.closeAll();
  }

}
